import { ShippingBox, StyledComponent } from '@on-arte/ui';
import styled from 'styled-components';

export const StyledShippingBox: StyledComponent<typeof ShippingBox> = styled(ShippingBox)`
  & + & {
    margin-top: 25px;
  }
`;
